import { call, put, takeLatest } from 'redux-saga/effects';

import * as ajax from '../../ajax';
import { CAMPAIGN_SOCIAL_POST_DELETE } from '../action-types';
import {
  campaignSocialPostDeleteFailed,
  campaignSocialPostDeleteRequested,
  campaignSocialPostDeleteSucceeded,
} from '../models/campaigns/campaigns.actions';

function* deleteSocialPost(action) {
  const { campaignId, ...payload } = action?.payload || {};

  yield put(
    campaignSocialPostDeleteRequested({
      id: payload?.twitter_id || payload?.instagram_id,
    })
  );

  try {
    yield call(ajax.deleteSocialPost, campaignId, payload);

    yield put(campaignSocialPostDeleteSucceeded(action.payload));
  } catch (e) {
    console.error('Campaign Social Post Delete Error - ', e);
    yield put(
      campaignSocialPostDeleteFailed({
        error:
          (e.bodyJson && e.bodyJson.errors) ||
          'Campaign Social Post Delete Error',
        id: payload?.twitter_id || payload?.twitter_id,
      })
    );
  }
}

export default function* root() {
  yield takeLatest(CAMPAIGN_SOCIAL_POST_DELETE, deleteSocialPost);
}
